const ApprovalprocessheaderData = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "ApprovedUserName", 
      label: "已审批人",
      columnwidth: 280,
      options: [
      ]
    },
    {
      prop: "CompletedText",
      label: "是否完结",
      columnwidth: 190,
    },
    {
      prop: "ApprovalTime",
      label: "审批时间",
      columnwidth: 318,
    },
  ];
  export default ApprovalprocessheaderData
  